import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M3 12.864c4.09-1.637 3.682.881 2.416 1.486-.465.222-1.722-.728-1.53-2.004.19-1.276 1.046-2.06 2.374-2.686 3.802-1.78 8.179-1.131 8.179-1.131s.563-1.287 1.643-1.332 1.676-.257 1.676.515-.383 1.712.259 2.574c.641.862.866 1.545.866 1.545s1.902-.347 2.025.213c.124.56.473 4.197-1.935 4.41s-2.925 1.802-3.06 2.832l-2.802-.045s-1.721-3.391-3.06.168l-2.97-.09s.517-1.287-1.294-2.361"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M9.545 12.046s2.005-.982 4.91-.237M11.182 5.09a1.227 1.227 0 1 1-2.455 0 1.227 1.227 0 0 1 2.455 0"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const MoneyIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
